import React from 'react';
import ReusableDemoPage from "../ReusableDemoPage";
import { cradlewiseConfig } from '../demoConfigs';

const CradlewiseDemo = () => {
  return <ReusableDemoPage config={cradlewiseConfig} />;
};

export default CradlewiseDemo;